import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  LocalizationProvider,
  DateTimePicker,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import moment from 'moment';

moment.locale('en');

const CustomDateTimePicker = ({
  label,
  value,
  onChange,
  disabled = false,
  isValidDate,
  placeholder = 'Select',
  sx,
  ampm = false,
  mode = 'datetime',
  ...props
}) => {
  const useAmpm = mode === 'time' || mode === 'datetime' ? true : Boolean(ampm);
  const inputFormat =
    mode === 'date'
      ? 'MM/DD/YYYY'
      : mode === 'time'
        ? 'hh:mm A'
        : 'MM/DD/YYYY hh:mm A';

  const commonProps = {
    label,
    value: value ? moment(value) : null,
    onChange: (newValue) => onChange(newValue),
    disabled,
    shouldDisableDate: isValidDate,
    ampm: useAmpm,
    inputFormat,
    renderInput: (params) => (
      <TextField
        {...params}
        placeholder={placeholder}
        sx={{
          ...sx,
          '& .MuiInputBase-root': {
            height: '30px',
            borderRadius: '10px',
            border: '1px solid #D9D9D9',
            backgroundColor: '#F9F9F9',
          },
          '& .MuiInputBase-input': {
            padding: '0 10px',
          },
        }}
      />
    ),
    ...props,
  };

  const getPickerComponent = () => {
    switch (mode) {
      case 'date':
        return <DatePicker {...commonProps} />;
      case 'time':
        return <TimePicker {...commonProps} />;
      default:
        return <DateTimePicker {...commonProps} />;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
      {getPickerComponent()}
    </LocalizationProvider>
  );
};

export default CustomDateTimePicker;
